<template>
  <modal
    name="upsellModal"
    :display-header-title="false"
  >
    <cf-upsell-items />
  </modal>
</template>


<script>
  import CfUpsellItems from './upsell-items/index.vue';


  export default {
    name: 'UpsellModal',

    components: {
      CfUpsellItems
    }
  };
</script>
